//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import DateFnsUtils from '@date-io/date-fns';
import { getDefaultDateFormat } from '../dateHelper';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const styles = theme => ({
    pickerTextFieldInput: {
        padding: '8px',
        fontSize: '14px',
        textAlign: 'center',
    },
    pickerTextFieldRoot: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
});

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getPickerTextField = (classes, props) => {
    const { pickerTextFieldInput: pickerTextFieldInputCls, pickerTextFieldRoot: pickerTextFieldRootCls } = classes;
    return (
        <TextField
            {...props}
            size="small"
            InputProps={{ disableUnderline: true, classes: { root: pickerTextFieldRootCls, input: pickerTextFieldInputCls, inputMarginDense: pickerTextFieldInputCls } }}
        />
    );
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AfitdDatePicker = props => {
    const { isHidden, children, classes, dateFormat = getDefaultDateFormat(), ...otherProps } = props;
    // const classes = useStyles();

    const defaultTimePickerProps = {
        variant: 'dialog',
        inputVariant: 'filled',
        // autoOk: true,
        format: dateFormat,
        TextFieldComponent: getPickerTextField.bind(null, classes),
    };

    if (isHidden) {
        return null;
    } else {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker {...defaultTimePickerProps} {...otherProps} />
            </MuiPickersUtilsProvider>
        );
    }
};

export default withStyles(styles)(AfitdDatePicker);
